import loadable from '@loadable/component';

export const CmsGradFairGradProgramLinksBlockLoadable = loadable(
  () => import('./CmsGradFairGradProgramLinksBlock'),
  { resolveComponent: (module) => module.CmsGradFairGradProgramLinksBlock },
);
